<template>
  <el-form class="page-search" inline>
    <el-form-item label="分类">
      <book-cate-selector
        v-model="search.data.tags"
        :clearable="true"
        size="small"
      />
    </el-form-item>

    <el-form-item label="书名">
      <el-input v-model="search.data.title" size="small" clearable />
    </el-form-item>

    <el-form-item label="借阅日期">
      <el-date-picker
        v-model="search.data.dateRange"
        type="daterange"
        size="small"
        :clearable="false"
        style="width: 260px"
      />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" size="small" @click="onSubmit">
        查询
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import store from './store'
import BookCateSelector from '../../book/shared/book-cate-selector.vue'

export default {
  components: {
    BookCateSelector
  },

  data() {
    return {
      search: store.search
    }
  },

  methods: {
    onSubmit() {
      store.search.onSubmit()
    }
  }
}
</script>
